import { BOOKING_DETAILS_ACTION_TYPE, GET_BOOKING_DETAILS_ACTION_TYPE, DELETE_TABLE_BOOKING_DETAILS_ACTION_TYPE,UPDATE_MEMBERSHIP_FILE_ACTION_TYPE,GET_PRICE_AND_TIME_ACTION_TYPE, CHECK_MEETING_SLOTS_ACTION_TYPE} from "../../utils/constants"

const initialState = [];

function bookingDetailsReducer(state = initialState, action) {
    const { type, payload } = action;
// console.log("type--12345",type)
// console.log("state--12345",[...state, payload])
    switch (type) {
        case BOOKING_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case GET_BOOKING_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case DELETE_TABLE_BOOKING_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case UPDATE_MEMBERSHIP_FILE_ACTION_TYPE:
            return [...state, payload];
        case GET_PRICE_AND_TIME_ACTION_TYPE:
            return [...state, payload];
        case CHECK_MEETING_SLOTS_ACTION_TYPE:
            return [...state, payload];
        default:
            return state;
    }
}

export default bookingDetailsReducer;
